import React, {useEffect, useState} from 'react'
import {useQuery} from '@tanstack/react-query'
import {QUERIES, toAbsoluteUrl} from '../../../../_metronic/helpers'
import {ListLoading, NoData} from '../../../../_component/ListLoading'
import {DefaultTitle} from '../_components/DefaultTitle'
import {getServices} from '../../../modules/apps/service/list/core/_requests'
import {Link, useLocation, useSearchParams} from 'react-router-dom'
import {useAuth} from '../../../modules/auth'
import {ListPagination, PaginationState} from '../_components/ListPagination'
import {useThemeMode} from '../../../../_metronic/partials'
import {useFormik} from 'formik'
import {getLocations, getMetadata} from '../../../modules/apps/location/list/core/_requests'
import {truncateString} from '../../../../_component/CustomFunctions'
import {getCategorys} from '../../../modules/apps/service/category/core/_requests'

const CatalogueListPage = () => {
  const {mode} = useThemeMode()
  const [state, setState] = useState<PaginationState>({page_number: 1, page_size: 9})
  const {business} = useAuth()
  const location = useLocation()
  const stylist_url = location.pathname.replace('services', 'staffs')
  const [filter, setFilter] = useState<any>({status: true})
  const [searchParams] = useSearchParams()
  const staff_id = searchParams.get('staff_id')
  useEffect(() => {
    if (staff_id) setFilter({...filter, staff_id})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [staff_id])
  const {isFetching, data: service} = useQuery(
    [
      `${QUERIES.SERVICES_LIST}-page_number=${state.page_number}&page_size=${
        state.page_size
      }&filter=${JSON.stringify(filter)}`,
    ],
    () => {
      let query = `page_number=${state.page_number}&page_size=${
        state.page_size
      }&filter=${JSON.stringify(filter)}`
      return getServices(query)
    },
    {keepPreviousData: true}
  )
  useEffect(() => {
    if (service) setState({...state, total: service.total_count, count: service.entities?.length})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [service])
  const updateState = (data: any) => {
    setState({...state, ...data})
  }

  const formik = useFormik({
    initialValues: {},
    // validationSchema: loginSchema,
    onSubmit: async (values) => {
      setFilter({...filter, ...values})
    },
  })
  const {data: cities} = useQuery(
    [`${QUERIES.METADATA_LIST}-city`],
    () => {
      return getMetadata('city')
    },
    {keepPreviousData: true}
  )
  const {data: states} = useQuery(
    [`${QUERIES.METADATA_LIST}-state`],
    () => {
      return getMetadata('state')
    },
    {keepPreviousData: true}
  )
  const {data: countries} = useQuery(
    [`${QUERIES.METADATA_LIST}-country`],
    () => {
      return getMetadata('country')
    },
    {keepPreviousData: true}
  )
  const {data: category} = useQuery(
    [`${QUERIES.CATEGORYS_LIST}`, `filter=${JSON.stringify({status: true})}`],
    () => {
      return getCategorys(`filter=${JSON.stringify({status: true})}`)
    },
    {keepPreviousData: true}
  )
  const {data: locations} = useQuery(
    [`${QUERIES.LOCATIONS_LIST}`, `filter=${JSON.stringify({status: true})}`],
    () => {
      return getLocations(`filter=${JSON.stringify({status: true})}`)
    },
    {keepPreviousData: true}
  )
  return (
    <>
      {isFetching && <ListLoading />}
      {!isFetching && !service?.entities?.length && <NoData />}
      <div className='d-flex flex-column flex-column-fluid'>
        {/*begin::Content*/}
        <DefaultTitle title='Catalogue' filter={filter} setFilter={setFilter} />
        <div id='kt_app_content' className='app-content flex-column-fluid'>
          {/*begin::Content container*/}
          <div id='kt_app_content_container' className='app-container container-xxl'>
            {/*begin::Row*/}
            <div className='row mb-5'>
              <div className='col-6 col-xxl-3 d-none d-xxl-block'>
                <div className='card h-xl-100'>
                  {/*begin::Header*/}
                  <div className='card-header border-0 pt-5'>
                    <h3 className='card-title align-items-start flex-column'>
                      <span className='card-label fw-bold text-dark'>Filter By Category</span>
                    </h3>
                  </div>
                  {/*end::Header*/}
                  {/*begin::Body*/}
                  <div className='card-body pt-6'>
                    <form>
                      {/*begin::Item*/}
                      <div className='d-flex flex-stack'>
                        {/*begin::Symbol*/}
                        <div className='form-check form-check-custom form-check-solid'>
                          <input
                            className='form-check-input'
                            type='radio'
                            value=''
                            id='flexRadioDefault'
                            name='category'
                            checked={!filter.category_id}
                            onChange={() => setFilter({...filter, category_id: undefined})}
                          />
                          <label className='form-check-label' htmlFor='flexRadioDefault'>
                            <div className='d-flex align-items-center flex-row-fluid flex-wrap'>
                              {/*begin:Author*/}
                              <div className='flex-grow-1 me-2'>
                                <a
                                  href='../../demo1/dist/pages/user-profile/overview.html'
                                  className='text-gray-800 text-hover-primary fs-6 fw-bold'
                                >
                                  View All
                                </a>
                                {/* <span className='text-muted fw-semibold d-block fs-7'>
                                {category?.total_count}
                              </span> */}
                              </div>
                              {/*end:Author*/}
                            </div>
                          </label>
                        </div>
                        {/*end::Section*/}
                      </div>
                      {/*end::Item*/}
                      {/*begin::Separator*/}
                      <div className='separator separator-dashed my-4'></div>
                      {/*end::Separator*/}
                      {/*end::Item*/}
                      {category?.entities?.map((entity, i) => (
                        <div key={i}>
                          {/*begin::Item*/}
                          <div className='d-flex flex-stack'>
                            {/*begin::Symbol*/}
                            <div className='form-check form-check-custom form-check-solid'>
                              <input
                                className='form-check-input'
                                type='radio'
                                value=''
                                id='flexRadioDefault'
                                name='category'
                                onChange={() => setFilter({...filter, category_id: entity.id})}
                              />
                              <label className='form-check-label' htmlFor='flexRadioDefault'>
                                <div className='d-flex align-items-center flex-row-fluid flex-wrap'>
                                  {/*begin:Author*/}
                                  <div className='flex-grow-1 me-2'>
                                    <span className='text-gray-800 text-hover-primary fs-6 fw-bold'>
                                      {entity.name}
                                    </span>
                                    {/* <span className='text-muted fw-semibold d-block fs-7'>
                                    40+ Courses
                                  </span> */}
                                  </div>
                                  {/*end:Author*/}
                                </div>
                              </label>
                            </div>
                            {/*end::Section*/}
                          </div>
                          {/*end::Item*/}
                          {/*begin::Separator*/}
                          <div className='separator separator-dashed my-4'></div>
                          {/*end::Separator*/}
                          {/*end::Item*/}
                        </div>
                      ))}
                    </form>
                    <form className='pt-5'>
                      <h6 className='fw-bold text-dark mb-7'>Filter by Service</h6>
                      <div className='mb-5'>
                        <select
                          aria-label='Select a Category'
                          className='form-select form-select-sm form-select-solid'
                          {...formik.getFieldProps('category_id')}
                        >
                          <option value=''>-- Service Category --</option>
                          {category?.entities?.map((e, i) => (
                            <option value={e.id} key={i}>
                              {e.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className='mb-5'>
                        <select
                          aria-label='Select a Service'
                          className='form-select form-select-sm form-select-solid'
                          {...formik.getFieldProps('service_id')}
                        >
                          <option value=''>-- Service --</option>
                          {service?.entities?.map((e, i) => (
                            <option value={e.id} key={i}>
                              {e.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <h6 className='fw-bold text-dark mb-7'>Filter by Location</h6>

                      <div className='mb-5'>
                        <select
                          aria-label='Select a Location'
                          className='form-select form-select-sm form-select-solid'
                          {...formik.getFieldProps('location_id')}
                        >
                          <option value=''>-- Location --</option>
                          {locations?.entities?.map((e, i) => (
                            <option value={e.id} key={i}>
                              {e.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className='row mb-8'>
                        <div className='mb-5 col-6'>
                          <select
                            aria-label='Select a Country'
                            className='form-select form-select-sm form-select-solid'
                            {...formik.getFieldProps('country')}
                          >
                            <option value=''>-- Country --</option>
                            {countries?.entities?.map((e, i) => (
                              <option value={e.value} key={i}>
                                {e.value}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className='mb-5 col-6'>
                          <select
                            aria-label='Select a State'
                            className='form-select form-select-sm form-select-solid'
                            {...formik.getFieldProps('state')}
                          >
                            <option value=''>-- State --</option>
                            {states?.entities?.map((e, i) => (
                              <option value={e.value} key={i}>
                                {e.value}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className='mb-5 col-6'>
                          <select
                            aria-label='Select a City'
                            className='form-select form-select-sm form-select-solid'
                            {...formik.getFieldProps('city')}
                          >
                            <option value=''>-- City --</option>
                            {cities?.entities?.map((e, i) => (
                              <option value={e.value} key={i}>
                                {e.value}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className='d-flex justify-content-end'>
                        {/* <button
                onClick={(e) => {
                  e.preventDefault()
                  setMenuState('main')
                }}
                className='btn btn-sm btn-light fw-bolder btn-active-light-primary me-2'
              >
                Cancel
              </button> */}

                        <button
                          type='button'
                          onClick={() => formik.handleSubmit()}
                          className='btn btn-sm fw-bolder btn-primary'
                          data-kt-search-element='advanced-options-form-search'
                        >
                          Search
                        </button>
                      </div>
                    </form>
                  </div>
                  {/*end::Body*/}
                </div>
              </div>
              <div className='col-12 col-xxl-9'>
                <div className='row g-5 mb-5 mb-xl-10'>
                  {/*begin::Col*/}
                  {service?.entities?.map((entity) => (
                    <div key={entity.id} className='col-sm-6 col-xxl-4'>
                      {/*begin::Card widget 14*/}
                      <div className='card card-flush h-xl-100'>
                        {/*begin::Body*/}
                        <div className='card-body text-center pb-5'>
                          {/*begin::Overlay*/}
                          <a
                            className='d-block overlay'
                            data-fslightbox='lightbox-hot-sales'
                            href={
                              entity.image_url
                                ? process.env.REACT_APP_BUCKET_URL + '/'! + entity.image_url
                                : '#'
                            }
                          >
                            {/*begin::Image*/}
                            <div
                              className='overlay-wrapper bgi-no-repeat bgi-position-center bgi-size-cover card-rounded mb-7'
                              style={{
                                height: '250px',
                                backgroundSize: 'contain',
                                backgroundImage: entity.image_url
                                  ? `url(${
                                      process.env.REACT_APP_BUCKET_URL + '/'! + entity.image_url
                                    })`
                                  : `url(${toAbsoluteUrl(
                                      `/media/svg/files/blank-image${
                                        mode === 'dark' ? '-dark' : ''
                                      }.svg`
                                    )})`,
                              }}
                            ></div>
                            {/*end::Image*/}
                            {/*begin::Action*/}
                            <div className='overlay-layer card-rounded bg-dark bg-opacity-25'>
                              <i className='bi bi-eye-fill fs-2x text-white'></i>
                            </div>
                            {/*end::Action*/}
                          </a>
                          {/*end::Overlay*/}
                          {/*begin::Info*/}
                          <div className='d-flex align-items-end flex-stack mb-1'>
                            {/*begin::Title*/}
                            <div className='text-start'>
                              <span className='fw-bold text-gray-800 cursor-pointer text-hover-primary fs-4 d-block'>
                                {truncateString(entity.name!, 25)}
                              </span>
                            </div>
                            {/*end::Title*/}
                          </div>
                          <div className='d-flex align-items-end flex-stack mb-1'>
                            {/*begin::Title*/}
                            <div className='text-start'>
                              <span className='text-gray-400 mt-1 fw-bold fs-6'>Price:</span>
                            </div>
                            {/*end::Title*/}
                            {/*begin::Total*/}
                            <span className='text-gray-600 text-end fw-bold fs-6'>
                              {entity.charge?.toLocaleString('en', {
                                style: 'currency',
                                currency: business?.CURRENCY || 'USD',
                              })}
                            </span>
                            {/*end::Total*/}
                          </div>
                          {/*end::Info*/}
                        </div>
                        {/*end::Body*/}
                        {/*begin::Footer*/}
                        <div className='card-footer d-flex flex-stack pt-0'>
                          {/*begin::Link*/}
                          <Link
                            className='btn btn-sm btn-primary flex-shrink-0 me-2'
                            to={'/' + location.pathname.split('/')[1] + '?service_id=' + entity.id}
                          >
                            Book Appointment
                          </Link>
                          {/*end::Link*/}
                          {/*begin::Link*/}
                          <Link
                            className='btn btn-sm btn-light-primary flex-shrink-0'
                            to={stylist_url + '?service_id=' + entity.id}
                          >
                            View Stylists
                          </Link>
                          {/*end::Link*/}
                        </div>
                        {/*end::Footer*/}
                      </div>
                      {/*end::Card widget 14*/}
                    </div>
                  ))}
                  {/*end::Col*/}
                </div>
                {service?.entities?.length ? (
                  <ListPagination
                    isLoading={isFetching}
                    updateState={updateState}
                    pagination={state}
                  />
                ) : (
                  <></>
                )}
              </div>
            </div>
            {/*end::Row*/}
          </div>
          {/*end::Content container*/}
        </div>
      </div>
    </>
  )
}
export default CatalogueListPage
